import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dek',
  templateUrl: './dek.component.html',
  styleUrls: ['./dek.component.css']
})
export class DekComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
